import { Check, X, Loader2, Minus, Circle } from "lucide-react";
import { cn } from "@/lib/utils";

const ICON = {
  done: <Check className="h-3.5 w-3.5" />, error: <X className="h-3.5 w-3.5" />, running: <Loader2 className="h-3.5 w-3.5 animate-spin" />,
  skipped: <Minus className="h-3.5 w-3.5" />, pending: <Circle className="h-2.5 w-2.5" />,
};
const CLS = {
  done: "bg-primary text-primary-foreground border-primary", error: "bg-red-500 text-white border-red-500",
  running: "bg-amber-500 text-black border-amber-500 pulse-dot", skipped: "bg-muted text-muted-foreground border-border", pending: "bg-card text-muted-foreground border-border",
};

export const JobTimeline = ({ steps }) => (
  <ol className="relative" data-testid="job-timeline">
    {steps.map((s, i) => (
      <li key={s.key} className="flex gap-4 pb-5 last:pb-0 relative" data-testid={`job-step-${s.key}`} data-status={s.status}>
        {i < steps.length - 1 && <span className={cn("absolute left-[13px] top-7 bottom-0 w-px", s.status === "done" || s.status === "skipped" ? "bg-primary/50" : "bg-border")} />}
        <span className={cn("h-7 w-7 rounded-full border grid place-items-center shrink-0 z-[1] transition-colors", CLS[s.status] || CLS.pending)}>{ICON[s.status] || ICON.pending}</span>
        <div className="min-w-0 pt-0.5">
          <p className={cn("text-sm font-medium", s.status === "pending" && "text-muted-foreground")}>{i + 1}. {s.label}</p>
          {s.message && <p className={cn("text-xs mt-0.5", s.status === "error" ? "text-red-400" : "text-muted-foreground")}>{s.message}</p>}
        </div>
      </li>
    ))}
  </ol>
);
